<!-- <div>
    MM Left: {{ currentRectangleLeftMM }} - MM Top: {{ currentRectangleTopMM }} - MM Right: {{ currentRectangleRightMM
    }} - MM
    Bottom: {{ currentRectangleBottomMM }}

    Ratio: {{pageWidthWithOrentation / queryCanvas.width }}
    queryCanvas.width: {{queryCanvas.width }}
    pageWidthWithOrentation: {{pageWidthWithOrentation }}
</div>
<div>
    topPdfPoint: {{ topPdfPoint }}
    leftPdfPoint: {{ leftPdfPoint }}
</div> -->
<div class="canvas-title">
    Margine superiore (mm): {{currentRectangleTopMM}}<br>Margine sinistro (mm): {{currentRectangleLeftMM}}
</div>
<div class="canvas-wrapper" [style.height]="initialWrapperHeight+'px'" #canvasWrapper="popper"
    (mousedown)="onMouseDown($event)" [popper]="tooltipErrTemplate"
    [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0"
    [popperTrigger]="ngxPopperjsTriggers.hover" popperApplyClass="error" [popperPlacement]="ngxPopperjsPlacements.TOP"
    [popperPreventOverflow]="false" [popperHideOnScroll]="true" popperAppendTo="body"
    [class.has-error]="showErrorBorder && errorList?.length > 0" (mouseup)="onMouseUp($event)"
    (touchmove)="onMouseMove($event)" (touchstart)="onMouseDown($event)" (touchend)="onMouseUp($event)"
    (mousemove)="onMouseMove($event)">
    <div class="canvas-ruler">
        <canvas #queryCanvas class="query-canvas">
        </canvas>
        <div class="canvas-placeholder"
            *ngIf="!(topPdfPoint >= 0 && topPdfPoint != null && leftPdfPoint >= 0 && leftPdfPoint != null)"
            (click)="createRect()">
            {{placeholder}}
        </div>

        <div class="canvas-ruler-x"
            [style.backgroundSize]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-x)) var(--ruler1-h), calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-x)) var(--ruler2-h), var(--ruler1-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-y)), var(--ruler2-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-y))'">
            <ul class="ruler-x"
                [style.insetInlineStart]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'">
                <li *ngFor="let item of tallsX"
                    [style.flexBasis]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'"></li>
            </ul>
        </div>

        <div class="canvas-ruler-y"
            [style.backgroundSize]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-x)) var(--ruler1-h), calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-x)) var(--ruler2-h), var(--ruler1-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-y)), var(--ruler2-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-y))'">
            <ul class="ruler-y" [style.insetBlockStart]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'">
                <li *ngFor="let item of tallsY"
                    [style.flexBasis]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'"></li>
            </ul>
        </div>
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of errorList">
        {{ item }}
    </ng-container>
</popper-content>
